import { CountryCode, parsePhoneNumberFromString } from "libphonenumber-js";

export const formatPhoneNumber = (
  phoneNumber: string | number,
  countryCode: string
): string => {
  const phone = parsePhoneNumberFromString(
    `+${phoneNumber}`,
    countryCode as CountryCode
  );

  if (phone) {
    return phone.formatInternational();
  } else {
    return "Invalid phone number";
  }
};
